export function normalizeValue(value, min, max) {
  const normalizedValue =  (value - min) * (1 - 0) / (max - min) + 0;
  return normalizedValue > 1 ? 1 : normalizedValue;
}